
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
const pageLoad = (pageLoadBO) => {
    try {
       
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ItemDetailNew,
            SDIConstants.methodNames.ItemDetailNew_Page_Load,
            JSON.stringify(pageLoadBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "TabOneResp", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/*[04/18/22,PC_WW-386_10], Priyanka D */
const EditImageSubmit = (EditImageBO) => {
    try {
     
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ItemDetailNew,
            SDIConstants.methodNames.UploadAlternativeItemImage,
            JSON.stringify(EditImageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "EditImgSubmit", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/*[04/18/22,PC_WW-386_05], Priyanka D */
const addAttachment = async (files) => {
    try {
       
        SDISVC.uploadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_AttachFiles,
            "",
            files,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "EditImgResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const addToCartItems = (addToCartItemsBO) => {
    try {
       
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ItemDetailNew,
            SDIConstants.methodNames.ItemDetailNew_imgBtnAddToCart_Click,
            JSON.stringify(addToCartItemsBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "addToCart", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const DeletFavItem = (deleteFavBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_DeleteFavItem,
            JSON.stringify(deleteFavBO),

            (data) => {
                if (data.success) {
                   
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.FavItemMaintenance_DeleteFavItem, response: data.response };
                      
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const TabClick = (TabClickBO) => {
    try {
     
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ItemDetailNew,
            SDIConstants.methodNames.ItemDetailNew_sdiTabStrip_TabClick,
            JSON.stringify(TabClickBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "TabClick", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

//WW-1216 Precart - Yuvarani K

const ItemDetail_ByPass = (AddCartBO) => {
    try {
        debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_AddToCart_Click,
            JSON.stringify(AddCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ItemDetail_ByPass", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};


//WW - 1216 Precart - Yuvarani K

const RatingSubmission = (RatingBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ItemDetailNew,
            SDIConstants.methodNames.InsertReview,
            JSON.stringify(RatingBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "RatingSubmissionresponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const catfavItem = (catfavItemBO) => {
    try {
      
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_InsertFavItem,
            JSON.stringify(catfavItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FavitemAdd", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const NoncatfavItem = (NoncatfavItemBO) => {
    try {
     
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.FavItemMaintenance,
            SDIConstants.methodNames.FavItemMaintenance_AddNonCatalogFavItem,
            JSON.stringify(NoncatfavItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FavitemAdd", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * *CIPA_PS_01
 * @param {any} BO
 */
const CheaperItemCheckAction = (BO) => {
    try {
  
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_Page_Load,
            JSON.stringify(BO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "CheaperItem", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};

//WW - 1216 Precart - Yuvarani K
const ItemDetail_dynamicFormData = (dynamicFormBO) => {
    try {
        debugger;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.Searchpage_dynamicFormClick,
            JSON.stringify(dynamicFormBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ItemDetail_DynamicForm", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
//[2/28/22], PC_IC_03, WW-316, Dhevanesam R
const GetRecommendedItems = (GetRecommendedItemsBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Searchpage,
            SDIConstants.methodNames.GetRecommendedItems,
            JSON.stringify(GetRecommendedItemsBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "GetRecommendedItems", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

export {
    //WW - 1216 Precart - Yuvarani K
    pageLoad, addToCartItems, TabClick, ItemDetail_ByPass, ItemDetail_dynamicFormData, NoncatfavItem, catfavItem, CheaperItemCheckAction, GetRecommendedItems, addAttachment, EditImageSubmit, DeletFavItem, RatingSubmission
}